<div [ngClass]="['mp-select', size, customClasses, outlinedColor ?? 'primary', outlinedStyle ?? 'solid']" #selectField
  tabindex="0"
  (click)="openSelectDropdown()"
  (keydown.enter)="openSelectDropdown()"
  [class.outlined]="outlined"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.opened]="displayDropdown()"
  [class.with-icon]="faIcon">
  <i [ngClass]="['mp-select-icon', faIcon, (outlined && outlinedColor) ? outlinedColor : '']"
    [class.without-value]="!hasValue()"
    *ngIf="faIcon"></i>
  <span *ngIf="!displaySelectedValue || !hasValue() as isEmpty"
    class="mp-select-label"
    [class.without-value]="isEmpty">
    {{ label | translate }}
  </span>
  <span *ngIf="displaySelectedValue" class="mp-select-field"
    [class.without-value]="!hasValue()">

    <span *ngIf="!optionLabelTemplate" class="mp-select-value"
      [mpTooltip]="getOverflowTooltip(selectValue)"
      [mpTooltipDisabled]="disabled || !isEllipsisActive()">
        {{ getOptionLabel(selectValue) | translate }}
    </span>

    <span *ngIf="optionLabelTemplate && !multiple" class="mp-select-value">
      <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: selectValue }"></ng-container>
    </span>

    <span *ngIf="optionLabelTemplate && multiple && Array.isArray(selectValue)" class="mp-select-value"
      [mpTooltip]="getOverflowTooltip(selectValue)"
      [mpTooltipDisabled]="disabled || !isEllipsisActive()">
        <div class="custom-multiple-value">
          <ng-container *ngFor="let option of selectValue; last as isLast">
            <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"></ng-container>
            <span *ngIf="!isLast">,</span>
          </ng-container>
        </div>
    </span>

  </span>
  <span class="reset-value" tabindex="0" *ngIf="!isReadOnly && canResetSelect()"
    (click)="resetSelectValue($event)"
    (keydown.enter)="resetSelectValue($event)">
    <i class="far fa-times-circle value-remove-icon"></i>
  </span>
  
  <app-mp-select-dropdown *ngIf="displayDropdown()"
    [anchor]="selectFieldElementRef"
    (keydown)="onDocumentKeydown($event)"
    (dropdownDisplayed)="autoCompleteField?.nativeElement?.focus()">
    <input class="select-autocomplete" type="text" #autoCompleteField
      *ngIf="autocompleteBehavior || fetchDataBehaviorAsync"
      [(ngModel)]="autocompleteValue"
      [ngModelOptions]="{standalone: true}"
      [placeholder]="autocompleteSearchLabel | translate"
      (ngModelChange)="autocompleteValueChanged($event)"/>
    <div class="select-option-wrapper"
      infiniteScroll
      [alwaysCallback]="true"
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="fetchAsyncData(false)">
      <div class="select-option" *ngFor="let option of availableOptions; let index = index"
        [class.highlighted]="index === highlightedOptionIndex"
        [class.selected]="isSelectedOption(option) && displaySelectedValue"
        (click)="onValueChanged(option)">

        <ng-container *ngIf="optionLabelTemplate">
          <mp-checkbox *ngIf="multiple" [label]="getOptionLabel(option)" [checked]="isChecked(option)" [size]="size">
            <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"/>
          </mp-checkbox>

          <span *ngIf="!multiple">
        <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"/>
      </span>
        </ng-container>

        <ng-container *ngIf="!optionLabelTemplate">
          <mp-checkbox *ngIf="multiple"
            [size]="size"
            [label]="getOptionLabel(option)"
            [checked]="isChecked(option)">
          </mp-checkbox>

          <span *ngIf="!multiple">{{ getOptionLabel(option) | translate }}</span>
        </ng-container>

      </div>
      <div class="select-option-loader" *ngIf="fetchingData">
        <i class="fas fa-spin fa-circle-notch"></i>
      </div>
    </div>
  </app-mp-select-dropdown>
</div>
